import './car-slider.scss';
import { initSwiperSlider } from '@/js/modules/swiper-slider.js';

const setupCarSlider = ( blockEl, sliderEl, initialInstance ) => {
	const toggleEl = blockEl.querySelector( '[data-car-slider-toggle]' );
	const templatesRoot = blockEl.querySelector( '.o-carSlider__templates' );

	if ( ! toggleEl || ! templatesRoot ) {
		return;
	}

	const buttons = toggleEl.querySelectorAll( '.a-toggleButton__item' );
	const wrapperEl = sliderEl.querySelector( '.swiper-wrapper' );
	const sliderId = sliderEl.getAttribute( 'id' );
	const headingEl = blockEl.querySelector( '[data-car-slider-heading]' );
	let currentInstance = initialInstance || null;
	let currentVariant = sliderEl.dataset.variant || 'business';

	let variants = [];
	try {
		if ( toggleEl.dataset.carSliderVariants ) {
			variants = JSON.parse( toggleEl.dataset.carSliderVariants );
		}
	} catch ( e ) {
		variants = [];
	}

	const templateEls = templatesRoot.querySelectorAll( '.o-carSlider__template' );
	const templates = {};

	templateEls.forEach( ( templateEl ) => {
		const variant = templateEl.dataset.variant;
		const variantWrapper = templateEl.querySelector( '.swiper-wrapper' );

		if ( variant && variantWrapper ) {
			templates[ variant ] = variantWrapper.innerHTML;
		}
	} );

	const updateToggleState = ( activeButton ) => {
		buttons.forEach( ( button ) => {
			const isActive = button === activeButton;

			button.classList.toggle( '-active', isActive );
			button.setAttribute( 'aria-pressed', isActive ? 'true' : 'false' );
			button.setAttribute( 'tabindex', isActive ? '0' : '-1' );
		} );
	};

	const updateHeading = ( targetVariant ) => {
		if ( ! headingEl ) {
			return;
		}

		const headingSpans = headingEl.querySelectorAll( '[data-variant]' );

		headingSpans.forEach( ( span ) => {
			const isActive = span.dataset.variant === targetVariant;

			if ( isActive ) {
				span.removeAttribute( 'hidden' );
				span.setAttribute( 'aria-hidden', 'false' );
			} else {
				span.setAttribute( 'aria-hidden', 'true' );
				span.setAttribute( 'hidden', 'hidden' );
			}
		} );
	};

	const switchVariant = ( targetVariant, activeButton ) => {
		if ( ! templates[ targetVariant ] || targetVariant === currentVariant ) {
			return;
		}

		sliderEl.classList.add( 'is-loading' );

		if ( currentInstance && typeof currentInstance.destroy === 'function' ) {
			currentInstance.destroy( true, true );
		}

		delete sliderEl.dataset.swiperInitialized;

		wrapperEl.innerHTML = templates[ targetVariant ];
		currentVariant = targetVariant;
		sliderEl.dataset.variant = targetVariant;
		updateHeading( currentVariant );

		const instances = initSwiperSlider( `#${ sliderId }`, {
			on: {
				init: function() {
					window.requestAnimationFrame( () => {
						sliderEl.classList.remove( 'is-loading' );
					} );
				},
			},
		} );
		currentInstance = instances && instances.length ? instances[ 0 ] : null;

		updateToggleState( activeButton );
	};

	buttons.forEach( ( button, index ) => {
		const variant = variants[ index ];

		if ( ! variant ) {
			return;
		}

		button.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			switchVariant( variant, button );
		} );
	} );
};

document.addEventListener( 'DOMContentLoaded', () => {
	const sliderSelector = '.o-carSlider .js-swiperSlider';
	const sliderEls = document.querySelectorAll( sliderSelector );

	sliderEls.forEach( ( sliderEl ) => {
		sliderEl.classList.add( 'is-initializing' );
	} );

	const instances = initSwiperSlider( sliderSelector, {
		on: {
			init: function() {
				const sliderElement = this.el;
				if ( sliderElement && sliderElement.classList.contains( 'is-initializing' ) ) {
					window.requestAnimationFrame( () => {
						sliderElement.classList.remove( 'is-initializing' );
					} );
				}
			},
		},
	} );

	sliderEls.forEach( ( sliderEl, index ) => {
		const blockEl = sliderEl.closest( '.o-carSlider' );

		if ( ! blockEl ) {
			return;
		}

		const instance = instances && instances.length ? instances[ index ] : null;

		if ( instance && sliderEl.classList.contains( 'is-initializing' ) ) {
			window.requestAnimationFrame( () => {
				sliderEl.classList.remove( 'is-initializing' );
			} );
		}

		setupCarSlider( blockEl, sliderEl, instance );
	} );
} );